"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeInputStateGroup = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var mobx_2 = require("../../state/mobx");
var input_state_1 = require("./input.state");
var INPUT_GROUP_TYPE = 'inputstategroup';
var IkeInputStateGroup = /** @class */ (function (_super) {
    tslib_1.__extends(IkeInputStateGroup, _super);
    function IkeInputStateGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._type = INPUT_GROUP_TYPE;
        _this.id = core_shared_1.IkeId.generate();
        _this.states = mobx_1.observable.map();
        _this.isLabelShown = true;
        _this.isAutoFocused = false;
        return _this;
    }
    IkeInputStateGroup.isInputStateGroup = function (input) {
        return input._type === INPUT_GROUP_TYPE;
    };
    IkeInputStateGroup.prototype.child = function (label, id, type, initialValue) {
        if (type === void 0) { type = input_state_1.InputStateTypes.TEXT; }
        var state = new input_state_1.InputState(label, id, type);
        this.add(state);
        if (initialValue != null) {
            state.setValue(initialValue);
        }
        return state;
    };
    IkeInputStateGroup.prototype.add = function (input) {
        if (this.states.has(input.id)) {
            throw new Error('Duplicate state added: ' + input.id);
        }
        this.states.set(input.id, input);
        if (!this.isLabelShown) {
            input.isLabelShown = this.isLabelShown;
        }
    };
    IkeInputStateGroup.prototype.get = function (id) {
        return this.states.get(id);
    };
    IkeInputStateGroup.prototype.remove = function (input) {
        this.states.delete(input.id);
    };
    IkeInputStateGroup.prototype.reset = function () {
        this.states.forEach(function (state) { return state.reset(); });
    };
    Object.defineProperty(IkeInputStateGroup.prototype, "isValid", {
        get: function () {
            var isValid = true;
            this.states.forEach(function (state) {
                if (!state.isValid) {
                    isValid = false;
                }
            });
            return isValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IkeInputStateGroup.prototype, "canSubmit", {
        get: function () {
            if (!this.isValid) {
                return false;
            }
            var isValid = true;
            this.states.forEach(function (state) {
                if (IkeInputStateGroup.isInputStateGroup(state)) {
                    if (!state.canSubmit) {
                        isValid = false;
                    }
                }
                else {
                    if (state.isRequired && !state.isFilled) {
                        isValid = false;
                    }
                }
            });
            return isValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IkeInputStateGroup.prototype, "isFilled", {
        get: function () {
            var isFilled = true;
            this.states.forEach(function (state) {
                if (!state.isFilled) {
                    isFilled = false;
                }
            });
            return isFilled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IkeInputStateGroup.prototype, "isRequired", {
        get: function () {
            var required = false;
            this.states.forEach(function (state) {
                if (state.isRequired === true) {
                    required = true;
                }
            });
            return required;
        },
        enumerable: false,
        configurable: true
    });
    IkeInputStateGroup.prototype.setDisabled = function (disabled) {
        this.states.forEach(function (state) { return state.setDisabled(disabled); });
    };
    IkeInputStateGroup.prototype.clearStates = function () {
        this.states.forEach(function (state) { return state.destroy(); });
        this.states.clear();
    };
    IkeInputStateGroup.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.clearStates();
    };
    IkeInputStateGroup.prototype.setAutoFocus = function (isAutoFocused) {
        // Not applicable
    };
    tslib_1.__decorate([
        mobx_1.action
    ], IkeInputStateGroup.prototype, "child", null);
    tslib_1.__decorate([
        mobx_1.action
    ], IkeInputStateGroup.prototype, "add", null);
    tslib_1.__decorate([
        mobx_1.action
    ], IkeInputStateGroup.prototype, "remove", null);
    tslib_1.__decorate([
        mobx_1.action
    ], IkeInputStateGroup.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], IkeInputStateGroup.prototype, "isValid", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], IkeInputStateGroup.prototype, "canSubmit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], IkeInputStateGroup.prototype, "isFilled", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], IkeInputStateGroup.prototype, "isRequired", null);
    tslib_1.__decorate([
        mobx_1.action
    ], IkeInputStateGroup.prototype, "setDisabled", null);
    tslib_1.__decorate([
        mobx_1.action
    ], IkeInputStateGroup.prototype, "clearStates", null);
    tslib_1.__decorate([
        mobx_1.action
    ], IkeInputStateGroup.prototype, "destroy", null);
    return IkeInputStateGroup;
}(mobx_2.MobxState));
exports.IkeInputStateGroup = IkeInputStateGroup;
//# sourceMappingURL=input.state.group.js.map